import { v4 as uuidv4 } from 'uuid';

/**
 * Check if a workspace needs migration from old flat layout to tabbed layout.
 */
export function needsMigration(workspace) {
  const lc = workspace?.layoutConfig;
  if (!lc) return true;
  // If tabs array exists and has items, already migrated
  if (Array.isArray(lc.tabs) && lc.tabs.length > 0) return false;
  return true;
}

/**
 * Migrate a workspace from old flat schema to tabbed schema.
 *
 * Old schema:
 *   workspace.layoutConfig.widgets = [...]
 *   workspace.notes = "..."
 *   workspace.timelineMarkers = [...]
 *
 * New schema:
 *   workspace.layoutConfig.tabs = [{ id, name, widgets, notes, timelineMarkers, rules, activeRuleIds }]
 *   workspace.layoutConfig.activeTabId = "..."
 *   workspace.layoutConfig.defaultTabId = "..."
 *   workspace.notes = "..."                  (stays as global notes)
 *   workspace.timelineMarkers = [...]        (stays as global markers)
 *
 * Migration wraps existing widgets into the first "Overview" tab.
 * Global notes and markers stay at workspace level.
 * The tab starts with empty notes/markers (user can add tab-level ones later).
 */
export function migrateWorkspace(workspace) {
  if (!needsMigration(workspace)) return workspace;

  const tabId = uuidv4();
  const existingWidgets = workspace.layoutConfig?.widgets || [];

  const overviewTab = {
    id: tabId,
    name: 'Overview',
    widgets: existingWidgets,
    notes: '',
    timelineMarkers: [],
    rules: [],
    activeRuleIds: [],
  };

  return {
    ...workspace,
    layoutConfig: {
      ...workspace.layoutConfig,
      widgets: [], // clear legacy field
      tabs: [overviewTab],
      activeTabId: tabId,
      defaultTabId: tabId,
      globalRules: workspace.layoutConfig?.globalRules || [],
      globalActiveRuleIds: workspace.layoutConfig?.globalActiveRuleIds || [],
    },
  };
}
